import { gql, QueryHookOptions, useQuery } from '@apollo/client';

import { NotificationCategory, NotificationChannel } from '../constants';

type NotificationPreferenceCategory = {
  id: string;
  name: NotificationCategory;
  userNotificationPreferences: UserNotificationPreference[];
};

export type UserNotificationPreference = {
  id?: string;
  channel: NotificationChannel;
  enabled: boolean;
};

type UserNotificationPreferenceCategory = NotificationPreferenceCategory & {
  userNotificationPreferences: UserNotificationPreference[];
};

export type GetUserNotificationPreferenceCategories = {
  getUserNotificationPreferenceCategories: UserNotificationPreferenceCategory[];
};

const getUserNotificationPreferenceCategoriesQuery = gql`
  query getUserNotificationPreferenceCategories {
    getUserNotificationPreferenceCategories {
      id
      name
      userNotificationPreferences {
        id
        channel
        enabled
      }
    }
  }
`;

export const useGetUserNotificationPreferences = (
  options?: QueryHookOptions<GetUserNotificationPreferenceCategories>
) =>
  useQuery<GetUserNotificationPreferenceCategories>(
    getUserNotificationPreferenceCategoriesQuery,
    options
  );
